import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tool from '@/utils/tool'
import './utils/fontRem.js'
import {
	Toast,
	showToast,
	closeToast,
	Overlay,
	Uploader,
	Image as VanImage,
	CountDown,
	Loading,
	Popover,
	List,
	showImagePreview,
	Popup,
	showDialog
 } from 'vant';
import 'vant/lib/index.css';
window.$ = window.jQuery = require('jquery')
// import Swiper from 'swiper'
// import 'swiper/swiper.min.css';


import './style/index.scss'

var url = window.location.href
if(url.match('^http://') && url.indexOf('h5.withfans.com') != -1 && tool.SERVER_PATH.indexOf('pay.withfans.com') == -1 && tool.SERVER_PATH.indexOf('www.withfans.com') != -1){
  url = url.replace(/^http:\/\//i,'https://');
  window.location.href = url
}
import VueClipboard from 'vue-clipboard2';
var app = createApp(App)

import utils from './utils/index'
app.config.globalProperties.$util = utils

app.config.globalProperties.$back = function() {
  if (window.history.length <= 1) {
    window.location.href = 'https://www.withfans.com/#/my'
    return false
  } else {
		router.go(-1)
  }
}

app.config.globalProperties.$toast = showToast
app.config.globalProperties.$dialog = showDialog
app.config.globalProperties.$closeToast = closeToast
app.config.globalProperties.$ImagePreview = showImagePreview

app.use(Toast)
app.use(Overlay)
app.use(Uploader)

app.use(VueClipboard)
app.use(VanImage)
app.use(CountDown)
app.use(Loading)
app.use(Popover)
app.use(List)
app.use(Popup)

app.use(store).use(router).mount('#app')
